(function () {
  var hasLogged = false;

  function replaceNoItemElement(element) {
    var emptyPageTemplate = document.getElementById('wishlist-empty-page-template');

    if (!emptyPageTemplate) return false;

    element.replaceChildren(emptyPageTemplate.content.cloneNode(true));
    return true;
  }

  function observeNoItemElement(wishlistContainer) {
    var observer = new MutationObserver(function () {
      var addedNoItemElement = wishlistContainer.querySelector('.wishlsitnoitem');

      if (!addedNoItemElement) return;

      if (!replaceNoItemElement(addedNoItemElement)) return;

      observer.disconnect();
    });

    observer.observe(wishlistContainer, { childList: true, subtree: true });
  }

  function initializeWishlistOverride() {
    var wishlistContainer = document.getElementById('wishlist-page-contain');
    if (!wishlistContainer) return false;

    var noItemElement = wishlistContainer.querySelector('.wishlsitnoitem');

    if (noItemElement) {
      replaceNoItemElement(noItemElement);
    } else {
      observeNoItemElement(wishlistContainer);
    }

    return true;
  }

  var intervalId = window.setInterval(function () {
    if (window.wishlistPageLoad !== true) return;

    if (!hasLogged) {
      hasLogged = true;
    }

    if (!initializeWishlistOverride()) return;

    window.clearInterval(intervalId);
  }, 50);
})();

/**
 * PP-987: add to cart from the wishlist page.
 *
 * The button of a wishlist entry belongs to the wishlist app, which puts the
 * product into the cart on its own. The theme did not notice that add: the cart
 * count in the header stayed as it was, and stores that confirm an add with the
 * add-to-cart popup showed neither the popup nor the warranty tiers of the product.
 *
 * The app reports every successful add to window.wishlistEngineCallback with the
 * response of the cart. From there the add is handed to the theme: every store
 * renders its cart surfaces freshly, and stores with the popup (theme setting
 * "Enable upsell popup instead of cart drawer") open it for the added product,
 * with the warranty tiers for business customers. Several products in one add
 * only refresh the cart.
 */

// Width of the product image inside the popup, the same the product forms pass on.
const POPUP_IMAGE_WIDTH = 100;

/** @param {unknown} error */
const reportHandOverError = (error) => {
  console.error('Wishlist add could not be handed over to the theme:', error);
};

/**
 * Units the clicked wishlist entry puts into the cart. The cart response carries
 * the quantity of the whole line, the button of the entry carries the units of
 * this add ("quntity" is the spelling of the app).
 * @param {string} variantId
 * @returns {number}
 */
function addedUnits(variantId) {
  const button = document.querySelector(
    `.wishlist-move-cart[data-variant_id="${CSS.escape(variantId)}"]`
  );
  const units = button instanceof HTMLElement ? Number(button.dataset.quntity) : 0;
  return units > 0 ? units : 1;
}

/**
 * Opens the add-to-cart popup for a line the wishlist app added
 * (atc-upsell-popup.js listens for the event).
 * @param {any} item - line item of the cart response
 * @param {number} units - units this add put into the cart
 */
async function showAddToCartPopup(item, units) {
  const { fetchWarrantyPopupOptions } = await import('@theme/product-form');
  const variantId = String(item.variant_id);
  const productId = String(item.product_id);
  const image = item.image
    ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=${POPUP_IMAGE_WIDTH}`
    : '';

  document.dispatchEvent(
    new CustomEvent('upsell-popup:show', {
      detail: {
        context: { handle: item.handle, title: item.product_title, image, productId },
        data: {
          variantId,
          itemCount: units,
          // The popup finds the added units by the properties of their line.
          addedProperties: item.properties ?? {},
          warrantyPopupOptions: fetchWarrantyPopupOptions({
            productUrl: `${window.Shopify?.routes?.root || '/'}products/${item.handle}`,
            productId,
            variantId,
          }),
        },
      },
    })
  );
}

/** @param {any} response - response of the cart to the add of the wishlist app */
window.wishlistEngineCallback = (response) => {
  // The app reports other actions here as well ("save for later"), those carry no items.
  const items = Array.isArray(response?.items) ? response.items : [];
  if (items.length === 0) return;

  // The app can be set to leave for the cart page right after the add.
  const staysOnPage = window.app_widget_data?.is_enable_stay_on_page_after_cart;
  if (staysOnPage !== undefined && Number(staysOnPage) !== 1) return;

  if (window.themeSettings?.enableUpsellPopup === true && items.length === 1) {
    const [item] = items;
    // The units are read right here: the app takes the entry off the list after this call.
    showAddToCartPopup(item, addedUnits(String(item.variant_id))).catch(reportHandOverError);
  }

  import('@theme/warranty-addons')
    .then(({ refreshCartSurfaces }) => refreshCartSurfaces())
    .catch(reportHandOverError);
};
